import { ServiceBase } from '../ServiceBase';
import { IClientDeviceService } from './client-device.service.interface';
import { IServiceFactoryExtended } from '../service-factory-extended.interface';
import { IClientDeviceDetected } from './detected/client-device.detected.interface';
import { IClientDeviceFeatures } from './features/client-device.features.interface';
import { ClientDeviceFeatures } from './features/client-device.features';
import { ClientDeviceDetected } from './detected/client-device.detected';

export class ClientDeviceService extends ServiceBase implements IClientDeviceService {
    public features: IClientDeviceFeatures;
    public detected: IClientDeviceDetected;

    constructor(services: IServiceFactoryExtended) {
        super(services);

        this.features = new ClientDeviceFeatures();
        this.detected = new ClientDeviceDetected();
    }
}
